module.exports = __webpack_public_path__ + "assets/img/hjinexenter.41fa119.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hjinexenter.png
// module id = /3Sz
// module chunks = 1